import React from "react"
import DeleteFilter from "../../../../assets/iconos/close.svg";
import { latest as API_URL } from "../../../../config/api";
import { barChart } from "../widgets/Charts";
import { months,getColorLeadtime } from "../../../../config/Helpers";

const postUrlLogin = API_URL + "widgets";

class General extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            general_table : "",
            year_table_active : [],
            month_table_active : [],
            hidden_widgets : ""
        }
    }

    getOptionTypeBar = (chart) => {
        
        let char_keys = Object.keys(this.props.response_request);
        let legends = [], xAxis = [], series = [];
        let self = this;
        let result
        if (char_keys.length > 0){
            result    = this.props.response_request["result"][chart];
            if(chart !== "data_adv_booking_intervals"){
                Object.keys(result).map(function(key){
                switch (key) {
                    case "legends":
                        legends = result[key];
                        break;
                
                    case "xAxis":
                        xAxis = result[key];
                        break;
                    
                    case "series":
                        series = Object.keys(result[key]).map(function(key_serie, index){
                            return {
                                name: key_serie,
                                color: self.state.array_colors[index],
                                type: "bar",
                                data: result[key][key_serie]
                            }
                        })
                        break;
                    }
                })
            }
        }
        return barChart("auto", legends, xAxis, series, self.props.view_results, this.props.current_year, this.props.past_year)
    }
    statusYear(year){
        let year_status = this.state.year_table_active;
        year_status[year] = year_status[year] === " active" ? " inactive" : " active";
        this.setState({
            year_table_active : year_status
        })
    }
    activeMonth(month){
        let mont_status = this.state.month_table_active;
        mont_status[month] = mont_status[month] === "active" ? "inactive" : "active";
        this.setState({
            month_table_active : mont_status
        })
    }
    componentWillReceiveProps(props){
        let char_keys = Object.keys(props.response_request);
        let self = this;
        if (char_keys.length > 0){
            let general_table = props.response_request["result"]["general_table"];
             Object.keys(general_table).map(function(key, index){
                self.state.month_table_active[key] = "active";
                let rows_month = "";
                if(parseInt(key) !== 0){
                    rows_month = Object.keys(general_table[key]).map(function(key_year){
                        self.state.year_table_active[key_year] = " active";

                    });
                }else{
                    rows_month = Object.keys(general_table[key]).map(function(key_year){
                        if(parseInt(key_year) !== 10000){
                            self.state.year_table_active[key_year] = " active";
                        }
                    });
                }
            })
        }
    }
    render() {
        let char_keys = Object.keys(this.props.response_request);
        let self = this;

        let first_child = true;
        if (char_keys.length > 0){
            let general_table = this.props.response_request["result"]["general_table"];
                self.state.hidden_widgets = Object.keys(general_table).map(function(key, index){
                    if(parseInt(key) !== 0){
                        return (  <span className={"wdg " + (self.state.month_table_active[key] === "inactive" ? "" : "hide")} onClick={ self.activeMonth.bind(self, key)} style={{ backgroundColor : getColorLeadtime(months[(key - 1)]) }}>
                            <div className="opt-w">
                                <span className="">{months[(key - 1)]}</span> <i className="fa fa-eye"></i>
                            </div>
                        </span> );
                    }
                });

            this.state.general_table = Object.keys(general_table).map(function(key, index){
                let rows_month = "";
                if(parseInt(key) !== 0){
                    rows_month = Object.keys(general_table[key]).map(function(key_year){
                        return Object.keys(general_table[key][key_year]).map(function(key_month, index_month){
                            const _show = self.state.year_table_active[key_year] === " active" ? "" : " hide";
                            const _class = (parseInt(key_month) !== 0) ? _show : "totals";
                            const _row_color = index_month%2 ? " row-c " : "";
                            return (<div className="row">
                                <div className={"col-md-12 datagrid-list "}>
                                    <div className={"datagrid-month " +_row_color + _class}>
                                        <div>{general_table[key][key_year][key_month]["room_nights"]}</div>
                                        <div>${general_table[key][key_year][key_month]["tariff"]}</div>
                                        {
                                            _class === "totals" ? 
                                                (<div> {general_table[key][key_year][key_month]["percent"]}%</div>) :
                                                (<div style={{width : 77, textAlign : "center"}}>
                                                    <div className="progress-field" style={{display: "inline-block", width : "44px",lineHeight : "30px", position : "relative", color : "#4da1ff", textAlign : "left"}}>
                                                        {general_table[key][key_year][key_month]["percent"]}%
                                                        <span style={{overflow : "hidden", position : "absolute", backgroundColor : "#4da1ff", left : 0, lineHeight : "30px", top : 0, width : general_table[key][key_year][key_month]["percent"]+"%",  color : "#FFFFFF"}}>{general_table[key][key_year][key_month]["percent"]}%</span>
                                                    </div>
                                                </div>)
                                        }
                                    </div>
                                </div>
                            </div>);
                            
                        });
                    });
                if(parseInt(key) === 1){
                    const style_totals = {
                        position : 'absolute'
                    }
                    return (<div style={style_totals} className={"datagrid-widget table-general " + (self.state.month_table_active[key] === "active" ? "" : "hide")}>
                        <div className="container-fluid">
                            <div className="row header-widget" style={{ backgroundColor : "#36a9e1" }}>
                                <div className="col-md-12 options-widget">
                                    <span className="title">TOTAL BY MONTHS</span>
                                    <span className="opt remove-widget">
                                        <img src={DeleteFilter} onClick={ self.activeMonth.bind(self, key)}/>
                                    </span>
                                </div>
                            </div>
                            <div className="current-values">
                                <div className="row">
                                    <div className="col-md-12 head-current">
                                        <span>R/N</span>
                                        <span>ADR</span>
                                        <span>%</span>
                                    </div>
                                </div>
                                {rows_month}
                            </div>   
                        </div>
                    </div>)
                }else{
                    let style_row = {}
                    if(first_child === true){
                        style_row = {
                            marginLeft : '15px'
                        }
                        first_child = false
                    }
                    return (<div style={style_row} className={"datagrid-widget table-general " + (self.state.month_table_active[key] === "active" ? "" : "hide")}>
                        <div className="container-fluid">
                            <div className="row header-widget" style={{ backgroundColor : getColorLeadtime(months[(key - 2)]) }}>
                                <div className="col-md-12 options-widget">
                                    <span className="title">{months[(key - 2)]}</span>
                                    <span className="opt remove-widget">
                                        <img src={DeleteFilter} onClick={ self.activeMonth.bind(self, key)}/>
                                    </span>
                                </div>
                            </div>
                            <div className="current-values">
                                <div className="row">
                                    <div className="col-md-12 head-current">
                                        <span>R/N</span>
                                        <span>ADR</span>
                                        <span>%</span>
                                    </div>
                                </div>
                                {rows_month}
                            </div>   
                        </div>
                    </div>)
                }
                
            }else{
                rows_month = Object.keys(general_table[key]).map(function(key_year){ 
                    if(parseInt(key_year) !== 10000){
                        return Object.keys(general_table[key][key_year]).map(function(key_month, index_month){
                            const _class = (parseInt(key_month) !== 0) ? (self.state.year_table_active[key_year] === " active" ? "" : " hide") : "totals";
                            const _row_color = index_month%2 ? " row-c " : "";
                            let row_group;
                            if(parseInt(key_month) === 0){
                                row_group = <div>
                                    {key_year} 
                                    <span className={"filter-row-year " + self.state.year_table_active[key_year]} onClick={self.statusYear.bind(self, key_year)} />
                                </div>
                            }else{
                                row_group = <div>{months[(key_month - 1)]}</div>
                            }
                            return (<div className="row">
                                <div className={"col-md-12 datagrid-list"}>
                                    <div className={"datagrid-month " + _row_color + _class}>
                                        {row_group}
                                    </div>
                                </div>
                            </div>);
                            
                        });
                    }else{
                        return (<div className="row">
                            <div className={"col-md-12 datagrid-list"}>
                                <div className={"datagrid-month totals"}>
                                    <div>TOTAL</div>
                                </div>
                            </div>
                        </div>);
                    }
                });
                return (<div className={"datagrid-widget table-general"}>
                    <div className="container-fluid">
                        <div className="row header-widget">
                            <div className="col-md-12 options-widget">
                                <span className="title">MONTHS</span>
                            </div>
                        </div>
                        <div className="current-values">
                            <div className="row">
                                <div className="col-md-12 head-current">
                                    <span>PERIODICITY</span>
                                </div>
                            </div>
                            {rows_month}
                        </div>   
                    </div>
                </div>
                )
            }
            })
        }
    
        return (<div>
            {this.state.general_table} 
            <div className={"hidden-widgets "} children={this.state.hidden_widgets}/>
        </div>)
    }
}

export default General



// WEBPACK FOOTER //
// ./src/Frontend/modules/marketing/lead-time/views/General.js